import { render, staticRenderFns } from "./MemberPortal.vue?vue&type=template&id=4030afb4"
import script from "./MemberPortal.vue?vue&type=script&lang=js"
export * from "./MemberPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports